<header class="d-flex align-items-center justify-content-between">
  <h2 class="text-dark head-title mb-0">
    {{ pageTitle.includes('>') ? pageTitle : (pageTitle | translate) }}
  </h2>

  <div class="user-info d-flex align-items-center gap-3">
    <div
      class="d-flex align-items-center gap-2 pointer"
      (click)="navigateToProfile()"
      (keydown.enter)="navigateToProfile()"
      (keydown.space)="navigateToProfile()"
      tabindex="0"
      role="button"
    >
      <img
        [src]="userInfo?.profile_picture | useHttpImgSrc: { userId: '', isPhysician: false, isProfile: true }"
        onerror="this.src='assets/images/avatar.svg'"
        alt="User Avatar"
        class="rounded-circle bg-white user-avatar"
      />
      <span class="fs-6 text-dark">{{ userInfo?.first_name | titlecase }} {{ userInfo?.last_name | titlecase }}</span>
    </div>

    <div>
      <button [matMenuTriggerFor]="menu" class="d-flex align-items-center border-0 bg-transparent">
        <img
          class="flag-img-mr rounded-1"
          alt="flag"
          src="assets/images/{{ this.currentLanguage === language.Arabic ? language.Arabic : language.English }}.svg"
        />
        <span class="eng-title-mob fw-medium">
          {{ this.currentLanguage === language.Arabic ? ('actions.ar' | translate) : ('actions.en' | translate) }}
        </span>

        <i class="das-down-arrow text-dark eng-dd-arrow"></i>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="switchLanguage(language.English)">
          <img src="assets/images/en.svg" alt="flag" /> {{ 'actions.en' | translate }}
        </button>

        <button mat-menu-item (click)="switchLanguage(language.Arabic)">
          <img src="assets/images/ar.svg" alt="flag" /> {{ 'actions.ar' | translate }}
        </button>
      </mat-menu>
    </div>
    <div
      class="d-flex align-items-center justify-content-between gap-2 pointer"
      (click)="onLogout()"
      (keydown.enter)="onLogout()"
      (keydown.space)="onLogout()"
      tabindex="0"
      role="button"
    >
      <i class="das das-edc-logout text-dark fs-4"></i> <span class="text-dark fs-6">{{ 'logout' | translate }}</span>
    </div>
  </div>
</header>
